module.exports={render:function (){with(this) {
  return _h('button', {
    on: {
      "click": handleClick
    }
  }, [_t("default")])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-03fd09dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
 ** module id = 162
 ** module chunks = 2
 **/